<template>
	<div>
		<div class="actDiv">
			<span style="color: red;">*</span>
			<a-input placeholder="请输入集中器地址" style="width: 12rem;font-size: 0.75rem;margin-left: 0.3125rem;" v-model="gprsAddr"/>
			<a-date-picker format="YYYY-MM-DD HH:mm:ss" style="margin: 0 0.85rem;" placeholder="起始时间" @change="onChangeStart" />
			<a-date-picker format="YYYY-MM-DD HH:mm:ss" style="margin-right: 0.85rem;" placeholder="截止时间" @change="onChangeEnd" />
			<a-button size="small" icon="search"    @click="searchIt"  :loading="loading">查询</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="gprsLogList" bordered  rowKey="id":scroll="{y:400}"  :loading="loading">
			<span slot="eventTypeSlot" slot-scope="text, record">
			      {{getEventType(record.event_type)}}
			</span>
			<span slot="createTimeSlot" slot-scope="text, record">
			      {{getCreateTime(record.create_time)}}
			</span>
		</a-table>
	</div>
</template>

<script>
	const columns = [
		{
			title: '序号',
			dataIndex: 'id',
			className:'v-cell',
			align:'center',
			width:100,
		},
		{
			title: '集中器地址',
			dataIndex: 'gprs_addr',
			className:'v-cell',
			align:'center',
			width:200,
		},
		{
			title: '状态',
			className:'v-cell',
			align:'center',
			scopedSlots: { customRender: 'eventTypeSlot' },
			width:100,
		},
		{
			title: '创建时间',
			className:'v-cell',
			align:'center',
			scopedSlots: { customRender: 'createTimeSlot' },
			width:160,
		},
	];
	export default {
		data(){
			return{
				columns,
				gprsLogList:[],
				gprsAddr:null,
				loading:false,
				beginTime:null,
				endTime:null,
			}
		},
		methods:{
			onChangeStart:function(moment){
				let date = new Date(moment);
				this.beginTime = this.Config.formatDate(date);
			},
			onChangeEnd:function(moment){
				let date = new Date(moment);
				this.endTime = this.Config.formatDate(date);
			},
			getEventType:function(type){
				if(type == '1'){
					return "上线";
				}
				if(type == '2'){
					return "下线";
				}
				return "";
			},
			getCreateTime:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			searchIt:function(){
				if(this.gprsAddr!=null && this.gprsAddr.length>0){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.SYSTEM_GET_GPRS_ONLINE_LOG_URL);
					let param = {gprsAddr:this.gprsAddr,beginTime:this.beginTime,endTime:this.endTime};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.gprsLogList = result;
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.loading = false;
						console.log(error);
					});
				}else{
					this.$message.error("请输入集中器地址");
				}
			},
		},
	}
</script>

<style>
</style>
